import { client } from "../utils/netlify";
import { generateNamedTags } from "./pdpHelpers/badgeHelpers";
import aa from "search-insights";
import insightsClient from "search-insights";
import { reportError } from "./errorHelper";

// This helper function fetching the product details and than transforms the tags in the format 
// which we receive from Algolia for PLPs
export const getProductTag = async (productId) => {
    let request = {}
    request.id = productId;
    try{
      let resp = await client("get-product-by-id", request)
      if(resp){
          let named_tags = await generateNamedTags(resp.tags);
          resp.named_tags = named_tags;
      }
      return resp;
    }catch(error){
      reportError("Error in getProductTag");
      reportError(error)
    }
}

export const getProductVariant = async (id) => {
  let request = {}
  request.id = id;
  try{
    let resp = await client("get-product-variant-by-id", request)
    
    return resp;
  }catch(error){
    reportError("Error in getProductVariant");
    reportError(error)
  }
}

export const getProductData = async (id) => {
  let request = {}
  request.id = id;
  try{
    let resp = await client("get-product-details-by-id", request)
    
    return resp;
  }catch(error){
    reportError("Error in getProductData");
    reportError(error)
  }
}

//function for tracking conversion events for algolia search tracking
export function algoliaConversionTracking(objectID,queryID,quickbuy){
  const appId= process.env.ALGOLIA_APPLICATION_ID;
  const apiKey = process.env.ALGOLIA_SEARCH_API_KEY;
  //it is compulsory to call insightsClient before calling aa function for initialization
  insightsClient('init', { appId, apiKey });

  //and to call aa function. convertedObjectIDsAfterSearch is used for conversion event passing to Algolia
  //All the params passed to the aa function are mandatory for search tracking
  //If the conversion is called via quickbuy then set the queryID else fetch from localstorage
  aa("convertedObjectIDsAfterSearch",{
    index: process.env.SHOPIFY_PRIMARY_INDEX,
    eventName: 'Product Conversion',
    queryID: quickbuy ? queryID : localStorage.getItem("queryID"),
    objectIDs: [objectID]
  })
}

//function to extract user id from _ga cookie (Only the last two value are used)
function extractGoogleAnalyticsUserIdFromCookie(gaCookie) {
  if (gaCookie) {
    // Remove the Google Analytics tracker from the device ID.
    const userIdParts = gaCookie.split('.').slice(-2);
    if (userIdParts.length === 2) {
      return userIdParts.join('_');
    }
  }
  return undefined;
}

//funtion to fetch the _ga cookie from the browser
function getBrowserCookie(cookieName) {
  if (typeof document !== 'object' || typeof document.cookie !== 'string') {
    return undefined;
  }
  const name = cookieName + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return undefined;
}

//function to get the user Id from the _ga browser cookie 
function getGoogleAnalyticsUserIdFromBrowserCookie(cookieName) {
  const browserCookie = getBrowserCookie(cookieName);
  if (!browserCookie) {
    return undefined;
  }
  return extractGoogleAnalyticsUserIdFromCookie(browserCookie);
}

//Fuction to set the user token extracted above
export function gaUserToken(){
  const userToken = getGoogleAnalyticsUserIdFromBrowserCookie('_ga');
  aa('setUserToken', userToken);
}